import { Component } from '@angular/core';

@Component({
  selector: 'app-general-instructions',
  templateUrl: './general-instructions.component.html',
  styleUrls: ['./general-instructions.component.scss']
})
export class GeneralInstructionsComponent {

}
